import React from 'react';
import './ReindexProgress.css';

interface ReindexProgressProps {
    job: any; // The reindex job object with progress details
    isVisible: boolean;
}

const ReindexProgress: React.FC<ReindexProgressProps> = ({ job, isVisible }) => {
    if (!isVisible || !job) {
        return null;
    }

    const {
        job_id,
        status,
        progress_details,
        processed_files = 0,
        total_files = 0
    } = job;

    const percentage = total_files > 0 ? Math.round((processed_files / total_files) * 100) : 0;

    return (
        <div className="reindex-progress-container">
            <div className="reindex-progress-header">
                <strong>Reindexing in Progress</strong>
                <span>(Job ID: {job_id})</span>
            </div>
            <div className={`reindex-progress-bar ${status}`}>
                <div className="reindex-progress-fill" style={{ width: `${percentage}%` }}></div>
            </div>
            <div className="reindex-progress-text">
                {status === 'running' && progress_details ? (
                    <>
                        <span>{percentage}% - {progress_details}</span>
                        <span className="file-counts">({processed_files} / {total_files})</span>
                    </>
                ) : (
                    <span>{status}</span>
                )}
            </div>
        </div>
    );
};

export default ReindexProgress; 